import { ComponentProps, useEffect, useRef } from "react";
import { Button } from "@tmca/toyota-kit";

import { setAttributes } from "../../helpers/utils";
import classNames from "classnames";

type ButtonTKProps = ComponentProps<typeof Button> & {
  customClassName?: string;
  gaDataButtonName?: string;
  qaId?: string;
  containerQaId?: string;
};

const TrackedButton = (props: ButtonTKProps) => {
  const { gaDataButtonName, qaId, containerQaId, children, customClassName, ...rest } =
    props;

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const btn = ref.current?.querySelector('[class*="_button_"]') as HTMLElement | null;
    if (!btn) return;

    setAttributes(btn, {
      ...(qaId && { "data-qa": qaId }),
      ...(gaDataButtonName && { "data-button-name": gaDataButtonName }),
    });
  }, [qaId, gaDataButtonName, containerQaId]);

  const getClassName = () => classNames("TrackedButton", customClassName);

  return (
    <div ref={ref} className={getClassName()}>
      <Button {...rest}>{children}</Button>
    </div>
  );
};

export default TrackedButton;
